



















import { Component, Prop, Vue } from 'vue-property-decorator';
import ProductType from '@/interfaces/ProductType';

@Component
export default class ProductTypeCard extends Vue {
  @Prop() private productTypeInfo!: ProductType;

  @Prop() private productTypeObject!: ProductType;

  @Prop() private dialogMode!: string;

  @Prop() private showDialog!: boolean;

  editProductType(productType: ProductType) {
    this.$emit('update:dialogMode', 'edit');
    this.$emit('update:showDialog', true);
    this.$emit('update:productTypeObject', productType);
  }
}
